import { DataGrid, Template } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  ColumnFixing,
  Editing,
  FilterRow,
  Grouping,
  HeaderFilter,
  Lookup,
  Paging,
  Popup,
  Position,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  ToolbarItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IRBForm from "./IRBForm";
import { init, updateAll, updateTaskCodeListId } from "./Redux/IRB";
import axios from "axios";
import { notifyMsg } from "../../../common/notify";
import VersionTracking from "./VersionTracking";
import VersionTrackingCell from "./VersionTrackingCell";
import { status } from "./data";
import DetailedCommentCell from "./DetailedCommentCell";

export default function IRBGrid(props) {
  const { sales } = props;

  const [IRBPopupVisible, setIRBPopupVisible] = useState(false);
  // const [step, setStep] = useState(0);

  const IRB = useSelector((state) => state.IRB);

  const dispatch = useDispatch();

  const IRBGridRef = useRef(null);

  const [taskDataSource, setTaskDataSource] = useState(null);
  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=IRB Submission&cat=13`
    );

    setTaskDataSource(result.data.code);

    dispatch(
      updateTaskCodeListId({
        taskCodeListId: result.data.codeListId,
      })
    );
  }, []);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["contrNo", "siteNo", "SEQ"],
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${sales.contrNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios
            .post(
              `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/${sales.contrNo}/${values.siteNo}`,
              values
            )
            .catch(function (error) {
              if (error) {
                notifyMsg(
                  "에러가 발생했습니다. 관리자에게 문의해주세요.",
                  "error"
                );
              }
            });
        },
        update: async (key, values) => {},
      })
    );
  }, [sales.contrNo]);

  const contentRender = useCallback(() => {
    return (
      <IRBForm
        sales={sales}
        IRB={IRB}
        IRBGridRef={IRBGridRef}
        taskDataSource={taskDataSource}
        setIRBPopupVisible={setIRBPopupVisible}
        // step={step}
        // setStep={setStep}
      />
    );
  }, [IRB]);

  const onInitNewRow = () => {
    const taskCodeListId = IRB.taskCodeListId;

    dispatch(init());

    if (taskCodeListId) {
      dispatch(
        updateTaskCodeListId({
          taskCodeListId: taskCodeListId,
        })
      );
    }

    setIRBPopupVisible(true);
    // setStep(0);
  };

  const calculateDisplaySUBIValue = (data) => {
    if (data && data.clinicalSiteSteps) {
      return data.clinicalSiteSteps.reduce(
        (accumulator, currentItem, index) => {
          if (currentItem.type == "1") {
            if (!accumulator) {
              return currentItem.name;
            } else {
              return accumulator + ", " + currentItem.name;
            }
          }
        },
        ""
      );
    } else {
      return ``;
    }
  };

  const versionTrackingCellRender = (data) => {
    // if (!data.value || Array.isArray(data.value)) {
    //   return;
    // }
    if (!data.value) {
      return;
    }

    return <VersionTrackingCell data={data} />;
  };

  const detailedCommentCellRender = (data) => {
    if (!data.value) {
      return;
    }

    return <DetailedCommentCell data={data} />;
  };

  const onEditingStart = (e) => {
    dispatch(
      updateAll({
        ...e.data,
        action: "update",
        step: 0,
      })
    );

    setIRBPopupVisible(true);
  };

  return (
    <DataGrid
      id="IRBGrid"
      ref={IRBGridRef}
      dataSource={dataSource}
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnResizingMode="widget"
      rowAlternationEnabled={true}
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      width={"100%"}
      height={"auto"}
      repaintChangesOnly={true}
      highlightChanges={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      style={{
        maxHeight: "800px",
      }}
      onInitNewRow={onInitNewRow}
      onEditingStart={onEditingStart}
    >
      <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
      <Grouping autoExpandAll={true} />
      <Scrolling
        mode={"virtual"}
        rowRenderingMode={"virtual"}
        columnRenderingMode={"virtual"}
        showScrollbar={"always"}
      />
      <HeaderFilter visible={true} />
      <FilterRow visible={true} applyFilter={"auto"} />
      <Paging enabled={false} />
      <Sorting mode={"multiple"} />
      <Selection mode={"single"} />
      <ColumnFixing enabled={true} />
      <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
        <Position
          my={"right top"}
          at={"right bottom"}
          of={".dx-datagrid-column-chooser-button"}
        />
      </ColumnChooser>

      <Editing
        refreshMode={"reshape"}
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
      >
        <Popup
          visible={IRBPopupVisible}
          showTitle={true}
          title={"IRB"}
          height={"auto"}
          showCloseButton={true}
          contentRender={contentRender}
        >
          <ToolbarItem toolbar={"top"} />
        </Popup>
      </Editing>

      <Template name="versionTracking" render={versionTrackingCellRender} />
      <Template name="detailedComment" render={detailedCommentCellRender} />

      <Column dataField={"contrNo"} caption={"Contract No."} visible={false} />
      <Column dataField={"siteNo"} caption={"Site No."} />
      <Column dataField={"siteName"} caption={"Site Name"} width={300} />
      <Column caption={"Clinical Site"}>
        <Column dataField={"CRA"} caption={"CRA"} />
        <Column dataField={"INSPCT_MANAGER_NAME"} caption={"PI"} />
        <Column
          dataField={"SUB-I"}
          caption={"Sub-I"}
          calculateDisplayValue={calculateDisplaySUBIValue}
        />
        <Column dataField={"CRC"} caption={"CRC"} />
        {/* <Column dataField={"apvNo"} caption={"IRB 승인번호"} />
        <Column dataField={"apvExpDate"} caption={"승인 유효기간"} /> */}
      </Column>
      <Column caption={"Version Tracking"}>
        <Column
          dataField={"PRT"}
          caption={"PRT"}
          cellTemplate={"versionTracking"}
          width={85}
        />
        <Column
          dataField={"IB"}
          caption={"IB"}
          cellTemplate={"versionTracking"}
          width={85}
        />
        <Column
          dataField={"pCRF"}
          caption={"pCRF"}
          cellTemplate={"versionTracking"}
          width={85}
        />
        <Column
          dataField={"eCRF"}
          caption={"eCRF"}
          cellTemplate={"versionTracking"}
          width={85}
        />
        <Column
          dataField={"ICF"}
          caption={"ICF"}
          cellTemplate={"versionTracking"}
          width={85}
        />
        <Column
          dataField={"otherDocs"}
          caption={"Others"}
          cellTemplate={"versionTracking"}
          width={85}
        />
      </Column>
      <Column caption={"IRB Related Activities"}>
        <Column dataField={"taskCodeId"} caption={"심의종류"}>
          <Lookup
            dataSource={taskDataSource}
            displayExpr={"name"}
            valueExpr={"codeId"}
            width={150}
          />
        </Column>
        <Column dataField={"count"} caption="Count (기관 및 심의종류별)" />
        <Column
          dataField={"detailedCmt"}
          caption="Detailed Comment"
          cellTemplate={"detailedComment"}
        />
        <Column dataField={"status"} caption="Status">
          <Lookup dataSource={status} displayExpr={"name"} valueExpr={"id"} />
        </Column>
        <Column
          dataField={"rcptDate"}
          caption={"Submission Date (IRB 접수일)"}
          width={150}
        />
        <Column dataField={"apvDate"} caption={"Approval Date"} width={130} />
        <Column dataField={"apvExpDate"} caption={"승인 유효기간"} />
        <Column dataField={"apvNo"} caption={"IRB 승인번호"} />
      </Column>
      <Column caption={"IRB 심사비"}>
        <Column dataField={"costExclVAT"} caption={"금액 (VAT제외)"} />
        <Column dataField={"depDate"} caption={"입금일"} width={100} />
        <Column dataField={"comment"} caption={"Comment (지급기준 포함)"} />
        <Column dataField={"claim"} caption={"청구 여부"} />
      </Column>
    </DataGrid>
  );
}
